module.exports = __webpack_public_path__ + "img/search.a0a0ab93.svg";